<template>

    <!-- 添加过滤自动完成框 -->
    <div class="filter-container">
      <div class="autocomplete-wrapper">
        <input
          v-model="searchText"
          @input="updateFilteredCategories"
          @focus="showDropdown = true"
          @blur="hideDropdown"
          @keydown.enter="handleEnter"
          placeholder="请输入分类名称进行搜索"
          class="filter-input"
          type="text"
        />
        <div v-show="showDropdown && filteredCategories.length > 0" class="autocomplete-dropdown">
          <div
            v-for="(category, index) in filteredCategories"
            :key="index"
            @mousedown="selectCategory(category)"
            class="autocomplete-item"
          >
            {{ category }}
          </div>
        </div>
      </div>
      <button @click="clearFilter" class="clear-button">清除筛选</button>
    </div>

    <!-- 添加加载状态显示 -->
    <div v-if="loading" class="loading">
      数据加载中...
    </div>

    <div v-else class="table-content">
      <!-- 遍历所有主分类 -->
      <div v-for="(mainCategory, mainKey) in filteredChipData" :key="mainKey" class="main-category">
        <!-- 主分类标题 -->
        <div class="main-category-header">{{ mainKey }}</div>

        <!-- 遍历子分类 -->
        <div v-for="(subCategory, subKey) in mainCategory" :key="subKey" class="sub-category">
          <!-- 子分类标题 -->

          <!-- 渲染表格数据 -->
          <div class="table-wrapper">
            <!-- 遍历具体内容 -->
            <div v-for="(content, contentKey) in subCategory" :key="contentKey">
              <!-- 如果内容是数组，直接显示 -->
              <div v-if="Array.isArray(content)" class="table-row">
                <div class="table-cell category-cell">
                  <a :href="`https://www.iwencai.com/unifiedwap/result?w=${contentKey}&querytype=stock`"
                     target="_blank"
                     class="category-link">
                    {{ contentKey }}
                  </a>
                </div>
                <div class="table-cell stocks-cell">
                  <span v-for="(stock, index) in parseStocks(content)" :key="index">
                    <a :href="`https://www.iwencai.com/unifiedwap/result?w=${stock}&querytype=stock`"
                       target="_blank"
                       class="stock-link">
                      {{ stock }}
                    </a>
                    <span v-if="index < parseStocks(content).length - 1">、</span>
                  </span>
                </div>
              </div>

              <!-- 如果内容是对象，继续展开 -->
              <div v-else>
                <!-- 主分类行 -->
                <div
                  v-for="(innerContent, innerKey, innerIndex) in content"
                  :key="innerKey"
                  class="table-row"
                  :class="{ 'rowspan-category': innerIndex === 0 }"
                >
                  <!-- 主分类名称只在第一行显示 -->
                  <div
                    v-if="innerIndex === 0"
                    class="table-cell category-cell"
                    :style="{ flex: '1' }"
                  >
                    <a :href="`https://www.iwencai.com/unifiedwap/result?w=${contentKey}&querytype=stock`"
                       target="_blank"
                       class="category-link">
                      {{ contentKey }}
                    </a>
                  </div>
                  <div v-else class="table-cell subcategory-cell"></div>

                  <!-- 子分类名称 -->
                  <div class="table-cell subcategory-cell">
                    <a :href="`https://www.iwencai.com/unifiedwap/result?w=${innerKey}&querytype=stock`"
                       target="_blank"
                       class="subcategory-link">
                      {{ innerKey }}
                    </a>
                  </div>

                  <!-- 股票列表 -->
                  <div class="table-cell stocks-cell">
                    <span v-for="(stock, index) in parseStocks(innerContent)" :key="index">
                      <a :href="`https://www.iwencai.com/unifiedwap/result?w=${stock}&querytype=stock`"
                         target="_blank"
                         class="stock-link">
                        {{ stock }}
                      </a>
                      <span v-if="index < parseStocks(innerContent).length - 1">、</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ChipConcept',
  data() {
    return {
      chipData: {},
      selectedCategory: '', // 选中的主分类
      mainCategoryNames: [], // 主分类名称列表
      loading: true,
      // 自动完成相关数据
      searchText: '',
      showDropdown: false,
      filteredCategories: [],
      allCategories: [] // 所有分类的扁平化列表
    }
  },
  computed: {
    filteredChipData() {
      if (!this.selectedCategory) {
        return this.chipData;
      }

      const filtered = {};
      filtered[this.selectedCategory] = this.chipData[this.selectedCategory];
      return filtered;
    }
  },
  mounted() {
    // 组件挂载时获取数据
    this.fetchChipData();
  },
  methods: {
    async fetchChipData() {
  try {
    // 调用后端接口获取数据
    const response = await axios.get('/api/chip-concept');
    this.chipData = response.data;

    // 提取主分类名称列表
    this.mainCategoryNames = Object.keys(this.chipData);

    // 创建所有分类的扁平化列表（包括子分类）
    this.allCategories = [...this.mainCategoryNames];
    Object.entries(this.chipData).forEach(([, mainValue]) => {
      Object.keys(mainValue).forEach(subKey => {
        if (!this.allCategories.includes(subKey)) {
          this.allCategories.push(subKey);
        }
      });
    });

    // 默认选择第一项（如果有数据）
    if (this.mainCategoryNames.length > 0) {
      this.selectedCategory = this.mainCategoryNames[0];
      this.searchText = this.mainCategoryNames[0];
    }
  } catch (error) {
    console.error('获取芯片概念数据失败:', error);
    // 可以添加错误提示
  } finally {
    this.loading = false;
  }
},


    filterData() {
      // 这个方法会在选择改变时自动触发computed属性更新
    },

    parseStocks(stockArray) {
      return stockArray;
    },

    // 自动完成相关方法
    updateFilteredCategories() {
      if (!this.searchText) {
        this.filteredCategories = [];
        this.selectedCategory = '';
        return;
      }

      const searchText = this.searchText.toLowerCase();
      this.filteredCategories = this.allCategories.filter(name =>
        name.toLowerCase().includes(searchText)
      );
    },

    selectCategory(category) {
      this.selectedCategory = category;
      this.searchText = category;
      this.showDropdown = false;
      this.filterData();
    },

    hideDropdown() {
      // 延迟隐藏以允许点击事件触发
      setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },

    handleEnter() {
      if (this.filteredCategories.length > 0) {
        this.selectCategory(this.filteredCategories[0]);
      }
    },

    clearFilter() {
      this.searchText = '';
      this.selectedCategory = '';
      this.filteredCategories = [];
    }
  }
}
</script>

<style scoped>
body {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  margin: 0;
  padding: 20px;
  background-color: #f5f5f5;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  overflow: hidden;
}

.header {
  background-color: #1890ff;
  color: white;
  text-align: center;
  padding: 20px;
  font-size: 24px;
  font-weight: bold;
}

.filter-container {
  margin: 20px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.autocomplete-wrapper {
  position: relative;
  flex: 1;
  max-width: 500px;
}

.filter-input {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.autocomplete-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #dcdfe6;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.autocomplete-item {
  padding: 10px 15px;
  cursor: pointer;
}

.autocomplete-item:hover {
  background-color: #f5f5f5;
}

.clear-button {
  padding: 10px 15px;
  background-color: #f5f5f5;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
}

.clear-button:hover {
  background-color: #e0e0e0;
}

.loading {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  color: #666;
}

.main-category-header {
  background-color: #1890ff;
  color: white;
  padding: 15px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-top: 10px;
}

.sub-category-header {
  background-color: #e6f7ff;
  color: #1890ff;
  padding: 12px 15px;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #e8e8e8;
}

.table-content {
  display: flex;
  flex-direction: column;
}

.table-wrapper {
  margin: 10px 0;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #e8e8e8;
}

.table-row:last-child {
  border-bottom: none;
}

/* 特殊行样式 */
.rowspan-category {
  background-color: #f0f9ff;
}

.table-cell {
  padding: 12px 15px;
  display: flex;
  align-items: center;
}

.category-cell {
  background-color: #e6f7ff;
  font-weight: bold;
  color: #1890ff;
}

.subcategory-cell {
  font-weight: bold;
  color: #595959;
  flex: 1;
}

.stocks-cell {
  flex: 6;
  color: #262626;
  line-height: 1.5;
}

.category-link,
.subcategory-link,
.stock-link {
  color: #1890ff;
  text-decoration: none;
}

.category-link:hover,
.subcategory-link:hover,
.stock-link:hover {
  text-decoration: underline;
}

.footer {
  background-color: #fafafa;
  text-align: center;
  padding: 15px;
  font-size: 14px;
  color: #8c8c8c;
  border-top: 1px solid #e8e8e8;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .table-row {
    flex-direction: column;
  }

  .subcategory-cell, .stocks-cell {
    flex: none;
    border-bottom: 1px solid #f0f0f0;
  }

  .stocks-cell {
    padding-top: 5px;
    padding-bottom: 15px;
  }

  .filter-container {
    flex-direction: column;
    align-items: stretch;
  }

  .autocomplete-wrapper {
    max-width: none;
    margin-bottom: 10px;
  }

  .clear-button {
    align-self: flex-start;
  }
}
</style>
